<script setup lang="ts">
import { RouterLink } from 'vue-router';

defineProps<{
  to: string;
}>();
</script>

<template>
  <RouterLink v-slot="{ isActive }" :to="to" class="flex flex-col items-center justify-center">
    <div
      class="flex flex-col items-center justify-center"
      :class="{ 'text-accent': isActive }"
      active-class="text-accent"
      @click="isActive && $event.preventDefault()"
    >
      <div class="flex h-5 w-5 items-center justify-center">
        <slot name="icon"></slot>
      </div>
      <span class="text-xs">
        <slot name="text"></slot>
      </span>
    </div>
  </RouterLink>
</template>
